<div cdkTrapFocus cdkTrapFocusAutoCapture>
    <h3 mat-dialog-title id="deposit-final-consent-dialog-title" data-test-id="deposit-consent-modal.title">Consent for Final Submission</h3>
    <button class="btn-close" type="button" aria-label="Close" *ngIf="!data.hideCloseButton" (click)="dialogRef.close(false)" data-test-id="deposit-consent-modal.close-button">
        <sm-icon name="close"></sm-icon>
    </button>
    <form>
        <mat-dialog-content>
            <form #form="ngForm" data-test-id="deposit-consent-modal.form">
                <div id="htmlPdf">
                    <ng-container [ngTemplateOutlet]="htmlPdf"></ng-container>
                    <ng-template #htmlPdf>
                        <img class="logo-img mb-12" *ngIf="showLogo" [src]="headerLogo" alt="Logo" width="168" height="auto"
                            data-test-id="deposit-consent-modal.logo"/>
                        <div tabindex="0" id="depositFinalConsentHTML" [innerHTML]="depositFinalConsentHTML"
                            data-test-id="deposit-consent-modal.consent-html"></div>
                    </ng-template>
                </div>
                <p class="mat-error text-sm-center text-start" *ngIf="errorMessage"
                        data-test-id="deposit-consent-modal.error-message">Please accept all agreements and terms.</p>
            </form>
            <div class="page-actions">
                <mat-bar-button [options]="downloadButtonOptions" name="download" id="downloadButton" (click)="print()"
                                data-test-id="deposit-consent-modal.download-button">
                </mat-bar-button>
                <mat-bar-button [options]="barButtonOptions" (tsSubmitIfValid)="accept()" name="accept" id="acceptButton"
                                data-test-id="deposit-consent-modal.accept-button">
                </mat-bar-button>
            </div>
            <p class="mb-0 mt-3" *ngIf="contentService.getContentText('TERMS_POP_UP.TEXT_BELOW_BUTTON')"
            [innerHTML]="contentService.getContentText('TERMS_POP_UP.TEXT_BELOW_BUTTON')"
            data-test-id="deposit-consent-modal.below-button-text"></p>
        </mat-dialog-content>
    </form>
    <iframe #iframe title="Print consent document" aria-hidden="true" data-test-id="deposit-consent-modal.print-iframe" tabindex="-1" style="position: absolute;top: -10000px;left: -10000px;"></iframe>
</div>
